angular.module('rjmNg.services').factory 'columnEditor', [
  () ->
    columnEditor = {}

    # Returns a formatted error details object, which can be set on a column.
    # The first argument is the error title, and any remaining arguments
    # each correspond to a line of input.
    columnEditor.getError = () ->
      [title, message...] = arguments

      title: title
      message: message

    # Get only the columns whose data_type is in typeFilter, an array of
    # permissible data types. If not dataType?, or dataType is empty, returns
    # all columns.
    columnEditor.filterColumnsByType = (columns, typeFilter) ->
      if typeFilter? and typeFilter.length > 0
        _.filter columns, (column) ->
          _.some typeFilter, (filter) ->
            filter is column?.data_type?.type
      else
        columns

    columnEditor
  ]
